import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Index from '../views/MemberManage/Index.vue'
import MemberInfoPage from '../views/MemberManage/MemberInfoPage.vue'
import CompanyChangeIndex from '../views/CompanyChange/CompanyChangeIndex.vue'
import CompanyChangeDetail from '../views/CompanyChange/CompanyChangeDetail.vue'
import SignUpRecord from '../views/SignUpRecord/SignUpRecord.vue'
import SignUpEdit from '../views/SignUpRecord/SignUpEdit.vue'
import SignUpDetail from '../views/SignUpRecord/SignUpDetail.vue'
import StudentInfoPage from '../views/StudentInfo/StudentInfoPage.vue'
import EditStudentInfoPage from '../views/StudentInfo/editStudentinfoPage.vue'
import StudentDetail from '../views/StudentInfo/StudentDetail.vue'
import MajorManagePage from '../views/MajorManage/MajorManagePage.vue'
import LookCompany from '../views/MemberManage/LookCompany.vue'
import BillList from '../views/BillList/BillList.vue'
import PaymentFlow from '../views/PaymentFlow/PaymentFlow.vue'
import SetUp from '../views/SetUp/SetUp.vue'
import cancelPage from '../views/StudentInfo/cancelPage.vue'


Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		redirect: "/Index",
		component: Home,
//		meta: {
//			isKeep: true
//		},
		children: [{
			path: '/Index',
			name: 'Index',
			component: Index,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/CompanyChangeIndex',
			name: 'CompanyChangeIndex',
			component: CompanyChangeIndex,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/MemberInfoPage',
			name: 'MemberInfoPage',
			component: MemberInfoPage,
		}, {
			path: '/CompanyChangeDetail',
			name: 'CompanyChangeDetail',
			component: CompanyChangeDetail,
		}, {
			path: '/SignUpRecord',
			name: 'SignUpRecord',
			component: SignUpRecord,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/SignUpDetail',
			name: 'SignUpDetail',
			component: SignUpDetail,
		}, {
			path: '/SignUpEdit',
			name: 'SignUpEdit',
			component: SignUpEdit,
		}, {
			path: '/StudentInfoPage',
			name: 'StudentInfoPage',
			component: StudentInfoPage,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/EditStudentInfoPage',
			name: 'EditStudentInfoPage',
			component: EditStudentInfoPage,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/StudentDetail',
			name: 'StudentDetail',
			component: StudentDetail,
		}, {
			path: '/MajorManagePage',
			name: 'MajorManagePage',
			component: MajorManagePage,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/LookCompany',
			name: 'LookCompany',
			component: LookCompany,
		}, {
			path: '/BillList',
			name: 'BillList',
			component: BillList,
			meta:{
				keepAlive:true
			}
		}, {
			path: '/PaymentFlow',
			name: 'PaymentFlow',
			component: PaymentFlow,
		}, {
			path: '/SetUp',
			name: 'SetUp',
			component: SetUp,
		}, {
			path: '/cancelPage',
			name: 'cancelPage',
			component: cancelPage,
		}],
	},
	{
		path: '/Login',
		name: 'Login',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import( /* webpackChunkName: "about" */ '../components/Login.vue')
	}
]

const router = new VueRouter({
	routes
})

export default router